var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7C9.2 7 8.75 6.55 8.75 6C8.75 5.74 8.85 5.49 9.04 5.3C9.23 5.11 9.48 5 9.75 5C10.3 5 10.75 5.45 10.75 6C10.75 6.55 10.3 7 9.75 7Z",
    fill: "#71737F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 19.5C4.37 19.5 0 15.13 0 9.75C0 4.37 4.37 0 9.75 0C15.13 0 19.5 4.37 19.5 9.75C19.5 15.13 15.13 19.5 9.75 19.5ZM9.75 1.5C5.2 1.5 1.5 5.2 1.5 9.75C1.5 14.3 5.2 18 9.75 18C14.3 18 18 14.3 18 9.75C18 5.2 14.3 1.5 9.75 1.5Z",
    fill: "#71737F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 15.5C9.34 15.5 9 15.16 9 14.75V9.75C9 9.34 9.34 9 9.75 9C10.16 9 10.5 9.34 10.5 9.75V14.75C10.5 15.16 10.16 15.5 9.75 15.5Z",
    fill: "#71737F"
  })));
};
export default SvgInfo;